// @flow
import FilterModel from "../filters/FilterModel";
import ChoiceAttributeModel from "../attributes/ChoiceAttributeModel";

import type { IFilter, ModelOptions } from "../types";

/**
 * The concept index model is a special filter used to index all first concept label letters in de modelcatalog.
 */
export default class ConceptIndexFilterModel
  extends FilterModel
  implements IFilter
{
  /**
   * Construct a filter
   */
  constructor(
    data: Object,
    contributions: Object,
    modelOptions?: ModelOptions,
  ) {
    super(data, contributions, modelOptions);

    if (this.attribute instanceof ChoiceAttributeModel) {
      const attribute: ChoiceAttributeModel = this.attribute;

      if (attribute && data.options) {
        const selectedValues = data.options
          .filter((option) => option.selected)
          .map((option) => option.key);

        data.options
          .filter((option) => !attribute.options.hasOptionByCode(option.key))
          .forEach((option) => {
            attribute.options.addOption(selectedValues, {
              code: option.key,
              label: option.key,
            });
          });
      }
    }
  }
}
